var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 6H18C13.5817 6 10 9.58172 10 14V30",
    stroke: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 23V31C37.5 33.3572 37.4993 35.0833 37.3482 36.4235C37.1982 37.7537 36.9055 38.6418 36.3634 39.3482C36.0708 39.7295 35.7295 40.0708 35.3482 40.3634C34.6418 40.9055 33.7537 41.1982 32.4235 41.3482C31.0833 41.4993 29.3572 41.5 27 41.5C24.6428 41.5 22.9167 41.4993 21.5765 41.3482C20.2463 41.1982 19.3582 40.9055 18.6518 40.3634C18.2705 40.0708 17.9292 39.7295 17.6366 39.3482C17.0945 38.6418 16.8018 37.7537 16.6518 36.4235C16.5007 35.0833 16.5 33.3572 16.5 31V23C16.5 20.6428 16.5007 18.9167 16.6518 17.5765C16.8018 16.2463 17.0945 15.3582 17.6366 14.6518C17.9292 14.2705 18.2705 13.9292 18.6518 13.6366C19.3582 13.0945 20.2463 12.8018 21.5765 12.6518C22.9167 12.5007 24.6428 12.5 27 12.5C29.3572 12.5 31.0833 12.5007 32.4235 12.6518C33.7537 12.8018 34.6418 13.0945 35.3482 13.6366C35.7295 13.9292 36.0708 14.2705 36.3634 14.6518C36.9055 15.3582 37.1982 16.2463 37.3482 17.5765C37.4993 18.9167 37.5 20.6428 37.5 23Z",
    stroke: "#F2F2F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e28d9c6e30959ceec97545b69cfd57f0.svg";
export { ForwardRef as ReactComponent };